import { render, staticRenderFns } from "./ModalTrueFalse.vue?vue&type=template&id=7b5d463f"
import script from "./ModalTrueFalse.vue?vue&type=script&lang=js"
export * from "./ModalTrueFalse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports